import { FrequencyValue } from './types'

export const FREQUENCY_VALUES = {
  HOURLY: 'hourly',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
} as const

export const frequencyOptions: Array<{ value: FrequencyValue; label: string }> = [
  { value: FREQUENCY_VALUES.HOURLY, label: 'Hourly' },
  { value: FREQUENCY_VALUES.DAILY, label: 'Daily' },
  { value: FREQUENCY_VALUES.WEEKLY, label: 'Weekly' },
  { value: FREQUENCY_VALUES.MONTHLY, label: 'Monthly' },
]

export const RUN_STATUS_VALUES = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  CANCELLED: 'CANCELLED',
  IN_PROGRESS: 'IN_PROGRESS',
  PLANNING: 'PLANNING',
} as const
